import $ from 'jquery';

$(function() {

    // initFeaturedProducts();

});

function initFeaturedProducts() {

    $('.featured-products-wrapper .header nav span').unbind('click');
    $('.featured-products-wrapper .header nav span').on('click', function() {
        let target = $(this).attr('data-header');
        $(this).siblings().removeClass('current');
        $(this).addClass('current');
        let $target = $('.featured-products-wrapper .product-tiles-wrapper[data-content=' + target + ']');
        $('.featured-products-wrapper .product-tiles-wrapper').not($target).fadeOut();
        $target.fadeIn();
    });

    $('.featured-products-wrapper .header .action').unbind('click');
    $('.featured-products-wrapper .header .action').on('click', function() {
        let $currentTab = $('.featured-products-wrapper .header nav span.current').first();
        let link = $currentTab.attr('data-link');
        if (link) {
            document.location.href = link;
        }
    });

    $('.featured-products-wrapper .product-tiles-controls i').unbind('click');
    $('.featured-products-wrapper .product-tiles-controls i').on('click', function() {
        let direction = 'right';
        if ($(this).hasClass('fa-circle-chevron-right')) {
            direction = 'left';
        }
        //let $tilesWrapper = $('.featured-products-wrapper .product-tiles-wrapper').not('.hide').first();
        let $tilesWrapper = $('.featured-products-wrapper .product-tiles-wrapper:visible').first();
        let $tiles = $tilesWrapper.find('.product-tiles').first();

        let width = ($($tilesWrapper.find('.product-tile')[1]).offset().left - $($tilesWrapper.find('.product-tile')[0]).offset().left);
        let productTilesLeft = parseFloat($tiles.css('left'));
        let left = 0;

        if (direction === 'left') {
            let productTilesWrapperWidth = $tilesWrapper.width();
            let productTilesWidth = $tiles.width();
            // Check if we have shifted a whole number of tiles
            left = (productTilesLeft - width);
            if (!Number.isInteger(left / width)) {
                left = (Math.ceil(left / width) * width);
            }
            // Set the new left value
            if (productTilesWrapperWidth < (productTilesWidth + productTilesLeft)) {
                $tiles.css('left', left + 'px');
            }
        } else {
            if (productTilesLeft < 0) {
                // Check if we have shifted a whole number of tiles
                left = (productTilesLeft + width);
                if (left > 0) {
                    left = 0;
                }
                // Set the new left value
                $tiles.css('left', left + 'px');
            }

        }

    });

}
